/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // ---- Global Transparent Header (all pages) ----
  // Force isHeaderTransparent = true on all pages when data-transparent is set
  // This enables scroll-based transparency toggling across the entire site
  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('header-component[data-transparent="true"]');
    if (!header) return;

    // Override isHeaderTransparent so the theme's scroll handler
    // keeps toggling the transparent class correctly on all pages
    window.isHeaderTransparent = true;

    // Add the transparent class immediately (for non-scrolled state)
    if (!document.body.classList.contains('has-scrolled')) {
      header.classList.add('site-header--transparent');
    }
  });





  // ---- Warranty: Utilities ----

  function generateWarrantyLinkId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  // In-memory cache: shoe_item_key → warranty_item_key
  var warrantyMap = {};
  var warrantyRefreshInProgress = false;

  function rebuildWarrantyMap(cart) {
    warrantyMap = {};
    if (!cart || !cart.items) return;
    var linkToWarrantyKey = {};
    cart.items.forEach(function(item) {
      if (item.properties && item.properties['_shoe_link']) {
        linkToWarrantyKey[item.properties['_shoe_link']] = item.key;
      }
    });
    cart.items.forEach(function(item) {
      if (item.properties && item.properties['_warranty_link']) {
        var wKey = linkToWarrantyKey[item.properties['_warranty_link']];
        if (wKey) warrantyMap[item.key] = wKey;
      }
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  // Finds orphaned warranties (shoe removed). Returns Promise<boolean>.
  function syncWarrantyItems() {
    return fetchCart().then(function(cart) {
      rebuildWarrantyMap(cart);
      var updates = {};
      var shoeLinks = {};
      cart.items.forEach(function(item) {
        if (item.properties && item.properties['_warranty_link']) {
          shoeLinks[item.properties['_warranty_link']] = item.quantity;
        }
      });
      cart.items.forEach(function(item) {
        if (!item.properties || !item.properties['_shoe_link']) return;
        var link = item.properties['_shoe_link'];
        if (!(link in shoeLinks)) updates[item.key] = 0; // orphaned warranty
      });
      if (Object.keys(updates).length === 0) return false;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() { return true; });
    });
  }

  // ---- Warranty: Checkbox toggle ----
  document.querySelectorAll('.warranty-b__checkbox').forEach(function(checkbox) {
    var optionsEl = checkbox.closest('.warranty-selector').querySelector('.warranty-b__options');
    if (!optionsEl) return;
    checkbox.addEventListener('change', function() {
      optionsEl.style.display = checkbox.checked ? 'flex' : 'none';
      if (checkbox.checked) {
        var firstRadio = optionsEl.querySelector('input[type="radio"]');
        if (firstRadio) firstRadio.checked = true;
      } else {
        optionsEl.querySelectorAll('input[type="radio"]').forEach(function(r) { r.checked = false; });
      }
    });
  });

  // ---- Warranty Selector (product page) ----
  function initWarrantySelectors() {
    document.querySelectorAll('product-form[data-form-wrapper]').forEach(function(productFormEl) {
      var warrantyOptions = productFormEl.querySelectorAll('.warranty-selector__option');
      warrantyOptions.forEach(function(option) {
        var radio = option.querySelector('input[type="radio"]');
        if (!radio) return;
        radio.addEventListener('change', function() {
          warrantyOptions.forEach(function(o) { o.classList.remove('warranty-selector__option--selected'); });
          option.classList.add('warranty-selector__option--selected');
        });
      });

      productFormEl.addEventListener('submit', function(evt) {
        var warrantyInput = productFormEl.querySelector('input[name^="warranty_choice"]:checked');
        if (!warrantyInput || !warrantyInput.value) return;

        var warrantyVariantId = parseInt(warrantyInput.value, 10);
        var warrantyTitle = warrantyInput.dataset.title;
        var linkId = generateWarrantyLinkId();
        var shoeProductTitle = productFormEl.dataset.productTitle || '';

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var form = productFormEl.querySelector('form[data-product-form]');
        if (!form) return;

        var formData = new FormData(form);
        var shoeVariantId = parseInt(formData.get('id'), 10);
        var quantity = parseInt(formData.get('quantity') || 1, 10);

        var shoeProperties = { 'Garanti': warrantyTitle, '_warranty_link': linkId };
        formData.forEach(function(value, key) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            shoeProperties[key.slice(11, -1)] = value;
          }
        });

        var submitButton = productFormEl.querySelector('[data-add-to-cart]');
        if (submitButton) {
          submitButton.classList.add('is-loading');
          submitButton.setAttribute('disabled', true);
        }

        var allWarrantyIds = Array.from(
          productFormEl.querySelectorAll('.warranty-selector__option input[type="radio"]')
        ).filter(function(i) { return i.value !== ''; })
         .map(function(i) { return parseInt(i.value, 10); });

        fetchCart()
          .then(function(cart) {
            var updates = {};
            cart.items.forEach(function(item) {
              if (allWarrantyIds.indexOf(item.variant_id) !== -1) updates[item.key] = 0;
            });
            if (Object.keys(updates).length > 0) {
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              });
            }
          })
          .then(function() {
            return fetch(window.theme.routes.cart_add_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [
                  { id: shoeVariantId, quantity: quantity, properties: shoeProperties },
                  { id: warrantyVariantId, quantity: quantity, properties: { '_shoe_link': linkId, 'Ürün': shoeProductTitle } }
                ]
              })
            });
          })
          .then(function(r) { return r.json(); })
          .then(function(response) {
            if (submitButton) {
              submitButton.classList.remove('is-loading');
              submitButton.removeAttribute('disabled');
            }
            if (response.status) {
              console.error('Warranty add to cart error:', response);
              return;
            }
            var cartDrawer = document.querySelector('cart-element[data-cart-drawer]');
            if (cartDrawer) {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            } else {
              window.location = window.theme.routes.cart_url;
            }
          })
          .catch(function(err) {
            console.error('Warranty cart error:', err);
            if (submitButton) {
              submitButton.classList.remove('is-loading');
              submitButton.removeAttribute('disabled');
            }
          });
      }, true);
    });
  }

  // ---- Warranty: Cart sync ----
  function initCartWarrantySync() {
    // Sync orphaned warranties after cart refresh (item added or drawer opened)
    document.addEventListener('theme:cart:refresh', function() {
      if (warrantyRefreshInProgress) return;
      warrantyRefreshInProgress = true;
      syncWarrantyItems()
        .then(function(changed) {
          warrantyRefreshInProgress = false;
          if (changed) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        })
        .catch(function(err) {
          warrantyRefreshInProgress = false;
          console.error('Warranty sync error:', err);
        });
    });

    // Intercept quantity changes → update shoe + warranty together in one request
    // theme:cart:update bubbles from [data-cart-item]; capture fires before CartElement's listener
    document.addEventListener('theme:cart:update', function(evt) {
      var itemKey = evt.detail && evt.detail.id;
      var newQty = evt.detail && parseInt(evt.detail.quantity, 10);
      if (!itemKey || isNaN(newQty) || !warrantyMap[itemKey]) return;

      evt.stopImmediatePropagation(); // we handle both shoe + warranty

      var updates = {};
      updates[itemKey] = newQty;
      updates[warrantyMap[itemKey]] = newQty;

      var cartItem = evt.target ? evt.target.closest('[data-cart-item]') : null;
      if (cartItem) cartItem.classList.add('is-loading');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function() { fetchCart().then(rebuildWarrantyMap); })
      .then(function() {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      })
      .catch(function(err) {
        console.error('Warranty qty update error:', err);
        if (cartItem) cartItem.classList.remove('is-loading');
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      });
    }, true);

    // Page load: clean stale warranties + build initial cache
    syncWarrantyItems()
      .then(function(changed) {
        if (!changed) return;
        if (document.querySelector('cart-element[data-cart-drawer]')) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } else if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function(err) { console.error('Warranty initial sync error:', err); });

    // Remove button: intercept when shoe has a paired warranty → remove both atomically
    document.addEventListener('click', function(evt) {
      var removeBtn = evt.target && evt.target.closest('[data-item-remove]');
      if (!removeBtn) return;
      var itemKey = removeBtn.getAttribute('data-id');
      if (!itemKey || !warrantyMap[itemKey]) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var cartItem = removeBtn.closest('[data-cart-item]');
      if (cartItem) cartItem.classList.add('is-loading');

      var updates = {};
      updates[itemKey] = 0;
      updates[warrantyMap[itemKey]] = 0;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function() {
        warrantyMap = {};
        // Cart page: theme:cart:refresh not listened → reload instead
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      })
      .catch(function(err) {
        console.error('Warranty remove error:', err);
        if (cartItem) cartItem.classList.remove('is-loading');
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      });
    }, true);
  }

  // ---- Customize: Cart Sync ----

  var customizeMap = {};
  var customizeRefreshInProgress = false;

  function rebuildCustomizeMap(cart) {
    customizeMap = {};
    if (!cart || !cart.items) return;
    var linkToCustomizeKey = {};
    cart.items.forEach(function(item) {
      if (item.properties && item.properties['_cust_shoe_link']) {
        linkToCustomizeKey[item.properties['_cust_shoe_link']] = item.key;
      }
    });
    cart.items.forEach(function(item) {
      if (item.properties && item.properties['_customize_link']) {
        var cKey = linkToCustomizeKey[item.properties['_customize_link']];
        if (cKey) customizeMap[item.key] = cKey;
      }
    });
  }

  function syncCustomizeItems() {
    return fetchCart().then(function(cart) {
      rebuildCustomizeMap(cart);
      var updates = {};
      var shoeLinks = {};
      cart.items.forEach(function(item) {
        if (item.properties && item.properties['_customize_link']) {
          shoeLinks[item.properties['_customize_link']] = item.quantity;
        }
      });
      cart.items.forEach(function(item) {
        if (!item.properties || !item.properties['_cust_shoe_link']) return;
        var link = item.properties['_cust_shoe_link'];
        if (!(link in shoeLinks)) updates[item.key] = 0;
      });
      if (Object.keys(updates).length === 0) return false;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() { return true; });
    });
  }

  function initCartCustomizeSync() {
    document.addEventListener('theme:cart:refresh', function() {
      if (customizeRefreshInProgress) return;
      customizeRefreshInProgress = true;
      syncCustomizeItems()
        .then(function(changed) {
          customizeRefreshInProgress = false;
          if (changed) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        })
        .catch(function(err) {
          customizeRefreshInProgress = false;
          console.error('Customize sync error:', err);
        });
    });

    // Quantity update: keep shoe + customize fee in sync
    document.addEventListener('theme:cart:update', function(evt) {
      var itemKey = evt.detail && evt.detail.id;
      var newQty = evt.detail && parseInt(evt.detail.quantity, 10);
      if (!itemKey || isNaN(newQty) || !customizeMap[itemKey]) return;

      evt.stopImmediatePropagation();

      var updates = {};
      updates[itemKey] = newQty;
      updates[customizeMap[itemKey]] = newQty;

      var cartItem = evt.target ? evt.target.closest('[data-cart-item]') : null;
      if (cartItem) cartItem.classList.add('is-loading');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function() { fetchCart().then(rebuildCustomizeMap); })
      .then(function() {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      })
      .catch(function(err) {
        console.error('Customize qty update error:', err);
        if (cartItem) cartItem.classList.remove('is-loading');
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      });
    }, true);

    // Remove button: atomically remove shoe + customize fee
    document.addEventListener('click', function(evt) {
      var removeBtn = evt.target && evt.target.closest('[data-item-remove]');
      if (!removeBtn) return;
      var itemKey = removeBtn.getAttribute('data-id');
      if (!itemKey || !customizeMap[itemKey]) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var cartItem = removeBtn.closest('[data-cart-item]');
      if (cartItem) cartItem.classList.add('is-loading');

      var updates = {};
      updates[itemKey] = 0;
      updates[customizeMap[itemKey]] = 0;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function() {
        customizeMap = {};
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      })
      .catch(function(err) {
        console.error('Customize remove error:', err);
        if (cartItem) cartItem.classList.remove('is-loading');
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      });
    }, true);

    // Page load: clean orphaned customize fees
    syncCustomizeItems()
      .then(function(changed) {
        if (!changed) return;
        if (document.querySelector('cart-element[data-cart-drawer]')) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } else if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function(err) { console.error('Customize initial sync error:', err); });
  }

  // ---- Bucks widget: move to footer slot ----
  function moveBucksToFooter() {
    var widget = document.querySelector('.buckscc-floating-box');
    var slot = document.getElementById('bucks-footer-slot');
    if (!widget || !slot || slot.contains(widget)) return;
    slot.appendChild(widget);
    // Override inline CSS custom properties to match footer theme
    var selectEl = slot.querySelector('.buckscc-select');
    if (selectEl) {
      selectEl.style.setProperty('--hxoSelect-color', 'rgba(255,255,255,1)', 'important');
      selectEl.style.setProperty('--hxoBackground', 'transparent', 'important');
      selectEl.style.setProperty('--hxoHover-bg', 'rgba(255,255,255,0.08)', 'important');
    }
    var optsList = slot.querySelector('.buckscc-select-options');
    if (optsList) {
      optsList.style.setProperty('--hxoSelect-color', 'rgba(255,255,255,1)', 'important');
      optsList.style.setProperty('--hxoBackground', '#1c1c1c', 'important');
      optsList.style.setProperty('--hxoHover-bg', 'rgba(255,255,255,0.08)', 'important');
    }
  }

  function initBucksFooter() {
    moveBucksToFooter();
    var bucksMoveTimer;
    var observer = new MutationObserver(function() {
      clearTimeout(bucksMoveTimer);
      bucksMoveTimer = setTimeout(moveBucksToFooter, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initWarrantySelectors();
    initCartWarrantySync();
    initCartCustomizeSync();
    initBucksFooter();
  });

  // Geri tuşu / form state restore: checkbox durumunu options görünürlüğüyle senkronize et
  window.addEventListener('pageshow', function() {
    document.querySelectorAll('.warranty-b__checkbox').forEach(function(checkbox) {
      var selector = checkbox.closest('.warranty-selector');
      if (!selector) return;
      var optionsEl = selector.querySelector('.warranty-b__options');
      if (!optionsEl) return;
      // Tarayıcı checkbox'ı işaretli restore ettiyse options'ı da göster; değilse gizle
      if (checkbox.checked) {
        optionsEl.style.display = 'flex';
        var firstRadio = optionsEl.querySelector('input[type="radio"]');
        if (firstRadio && !optionsEl.querySelector('input[type="radio"]:checked')) {
          firstRadio.checked = true;
        }
      } else {
        optionsEl.style.display = 'none';
        optionsEl.querySelectorAll('input[type="radio"]').forEach(function(r) { r.checked = false; });
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
